import React from 'react';
import { connect } from 'react-redux';
import { buildUrlAndOpenWindow } from '../../../../../utilities/StringHelpers/StringHelpers';

function MessageNoProdact({ indexProdact, epiData, isShowPage, equipmentsTv, equipmentsInternet, haveInternet, haveTv }) {
    const clickButton = () => {
        switch (indexProdact) {
            case 0:
                buildUrlAndOpenWindow(epiData.linkInternet);
                break;
            case 1:
                buildUrlAndOpenWindow(epiData.linkTv);
                break;
            default:
                console.warn("ערך לא תקין של indexProdact");
        };
    };
    
    const checkMessageDisplay = () => {
        const isInternetTab = Number(indexProdact) === 0;
        const isTvTab = Number(indexProdact) === 1;
        const noInternetEquipment = !equipmentsInternet || equipmentsInternet.length < 1;
        const noTvEquipment = !equipmentsTv || equipmentsTv.length < 1;

        if (isInternetTab) {
            if (noInternetEquipment && !haveInternet) {
                return 'no-internet';
            }
            if (noInternetEquipment && haveInternet) {
                return 'noequipmentsInternet';
            }
        }

        if (isTvTab) {
            if (noTvEquipment && !haveTv) {
                return 'noTv';
            }
            if (noTvEquipment && haveTv) {
                return 'noequipmentsTV';
            }
        }

        return null;
    };

    const messageType = checkMessageDisplay();
   
    const renderContent = () => {
        switch (messageType) {
            case 'no-internet':
                return (
                    <>
                        <div className="wrapper-mes-equipments mes-with-tab">
                            <div className="title">עדיין אין לך אינטרנט של {window.Config.brand_Name_HE}? </div>
                            <div className="content">הגיע הזמן להצטרף וליהנות מחוויית גלישה מתקדמת!</div>
                        </div>
                    </>
                );
            case 'noTv':
                return (
                    <>
                        <div className="wrapper-mes-equipments mes-with-tab">
                            <div className="title">עדיין אין לך {window.Config.brand_Name_HE} TV?</div>
                            <div className="content">הגיע הזמן להצטרף וליהנות מחווית צפייה מעולה!</div>
                        </div>
                    </>
                );
                case 'noequipments':
                    return (
                        <>
                            <div className="wrapper-mes-equipments">
                                <div className="title">נראה שאין לך עדיין ציוד <br></br>אינטרנט או טלוויזיה אצלנו</div>
                                <div className="content">
                                    בדקו את מגוון האפשרויות שלנו והתאימו את הציוד<br></br> שמתאים לכם לחווית גלישה וצפייה מושלמת
                                </div>
                            </div>
                        </>
                    );
                case 'noequipmentsInternet':
                    return (
                        <>
                            <div className="wrapper-mes-equipments mes-with-tab">
                                <div className="title">  נראה שאין לך ציוד אינטרנט אצלינו </div>
                                <div className="content" >
                                    תמיד אפשר להזמין אצל נציג <span style={{ direction: 'ltr', display: 'inline-block' }}> {window.Config.technicalSupportPhone} </span>                                 
                                </div>
                            </div>
                        </>
                    );
                case 'noequipmentsTV':
                        return (
                            <>
                                <div className="wrapper-mes-equipments mes-with-tab">
                                    <div className="title"> נראה שאין לך ציוד TV אצלינו </div>
                                    <div className="content" >
                                       תמיד אפשר להזמין אצל נציג <span style={{ direction: 'ltr', display: 'inline-block' }}> {window.Config.technicalSupportPhone} </span>                                 
                                    </div>
                                </div>
                            </>
                        );
                default: 
                break;
        };
    };

    return (
        <div className="message-no-prodact">
           {renderContent()}
          {(messageType === 'no-internet' || messageType === 'noTv' || messageType === 'noequipments') &&
           <button className={!equipmentsInternet && !equipmentsTv && isShowPage ? 'button-wrapper-mes' : ''} onClick={clickButton}>תצרפו אותי</button> 
          }
        </div>
    );
};

const mapStateToProps = (state) => ({
    epiData: state.equipmentMinePage.epiData,
    indexProdact: state.equipmentMinePage.indexProdact,
    equipmentsInternet: state.equipmentMinePage.equipmentsInternet,
    equipmentsTv: state.equipmentMinePage.equipmentsTv,
    haveTv: state.equipmentMinePage.haveTv,
    haveInternet: state.equipmentMinePage.haveInternet,
});

export default connect(mapStateToProps)(MessageNoProdact);
